// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"19b9679e","659":"63b2f226"}[chunkId] + ".chunk.js";
};